import axios from "axios";
import React, { useContext, useState } from "react";
import { useCookies } from "react-cookie";
import { IoClose } from "react-icons/io5";
import globalContext from "../../Contexts/GlobalContext";
import { useNavigate } from "react-router-dom";
import BlueLoader from "../loader/BlueLoader";
import { SERVERMODE } from "../../constants/serverMode";
import { handleServerMode } from "../../utils/handleServer";
import useRequestHeader from "../../hooks/useRequestHeader";
export default function IdentifyCode() {
  /// root api address section start ///
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;
  /// root api address section end ///
  const contextData = useContext(globalContext);
  const requestHeader = useRequestHeader();
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [identifyCode, setIdentifyCode] = useState("");
  const [cookies, setCookies, removeCookies] = useCookies();
  const navigate = useNavigate();
  const sendIdentifyCode = () => {
    setErrorMessage("");
    setIsLoading(true);
    const config = {
      headers: requestHeader,
    };
    axios
      .post(
        `${BASE_URL}/user/identifiCode`,
        {
          identifier: identifyCode,
        },
        config
      )
      .then((res) => {
        var responseMode = res?.data?.Mode;
        var responseMessage = res?.data?.Message;
        switch (responseMode) {
          case SERVERMODE.REQUEST_OK: {
            navigate("/driver-info");
            break;
          }
          case SERVERMODE.USER_NOT_FOUND_IDENTIFI: {
            setErrorMessage("کد دعوت کاربر اشتباه است");
            break;
          }
          case SERVERMODE.USER_UNABLE_SET_IDENTIFI: {
            setErrorMessage("کد دعوت قبلا ثبت شده است");
            break;
          }
          default: {
            handleServerMode(
              responseMode,
              responseMessage,
              contextData,
              cookies,
              removeCookies,
              navigate
            );
          }
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setErrorMessage("ارتباط با سرور دچار مشکل شده است");
        setIsLoading(false);
      });
  };
  return (
    <>
      <div
        className={`absolute h-[100vh]  w-[100vw] z-[1000] backdrop-blur-sm `}
      ></div>

      <div
        className="bg-[#153038] absolute w-full flex flex-col items-center justify-start font-font_primary_A h-auto p-[8vw]   rounded-t-[2.8vw] z-[10000] up "
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="w-full flex items-center justify-between font-font_primary_A  text-[#FFF]">
          <span className="text-[4vw]"> کد معرف دارید؟</span>
        </div>
        <div className="w-full flex items-center justify-center mt-[4vw]">
          <input
            type="text"
            name=""
            id=""
            dir="ltr"
            maxLength={7}
            value={identifyCode}
            className=" w-full h-[10vw] font-font_primary_A focus:font-font_primary_A text-[4.5vw] outline-none  rounded-[1.8vw] text-center"
            onChange={(e) => {
              setIdentifyCode(e.target.value);
            }}
          />
        </div>
        <div className="w-full flex items-center justify-start font-font_primary_A text-[3.5vw] text-red-500 mt-[2vw] ">
          <span>{errorMessage}</span>
        </div>

        <div className="w-full flex items-center justify-between mb-[4vw] gap-x-[2vw] mt-[4vw] ">
          <div className="w-1/2 flex items-center justify-center text-[#FFF] ">
            <button
              className="w-full bg-transparent border-[1px] border-color-primary-B font-font_primary_A text-[3.5vw] p-[2vw]  rounded-[1.8vw]"
              onClick={() => {
                navigate("/driver-info");
              }}
            >
              کد معرف ندارم
            </button>
          </div>
          <div className="w-1/2 flex items-center justify-center ">
            {isLoading ? (
              <div className="w-full bg-[#fdb92e] flex items-center justify-center  font-font_primary_A text-[3.5vw] p-[2vw]  rounded-[1.8vw]">
                <BlueLoader position="relative" width={5.25} />
              </div>
            ) : (
              <button
                className="w-full bg-[#fdb92e] flex items-center justify-center font-font_primary_A text-[3.5vw] p-[2vw]  rounded-[1.8vw]"
                onClick={sendIdentifyCode}
              >
                ثبت کد
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
